(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wohnjoy-delivery-display"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wj-delivery-window')) {
  customElements.define('wj-delivery-window', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.value = this.querySelector('[data-wj-delivery-value]');
      this.dot = this.querySelector('.wj-delivery-dot');
      this.state = this.querySelector('[data-wj-delivery-state]');
      this.body = this.closest('details')?.querySelector('[data-wj-delivery-body]');
      this.durationLabel = this.value?.textContent.trim();
      this.renderValue();
      document.addEventListener('change', event => {
        if (event.target.name !== 'id') return;
        const form = event.target.closest('form');
        if (!form || ![`product-form-${this.dataset.section}`, `sticky-addcart-form-${this.dataset.section}`].includes(form.getAttribute('id'))) return;
        this.load(event.target.value);
      }, {signal: this.events.signal});
      const input = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="id"]');
      if (input?.value && (input.value !== this.dataset.variant || this.needsRefresh)) {
        this.needsRefresh = false;
        this.load(input.value);
      }
    }
    disconnectedCallback() {
      this.needsRefresh = Boolean(this.pending);
      this.events?.abort();
      this.request?.abort();
      clearInterval(this.timer);
      this.events = null;
      this.pending = null;
      this.request = null;
    }
    renderValue() {
      clearInterval(this.timer);
      const confirmed = this.dataset.confirmed === 'true';
      const available = this.dataset.available === 'true';
      this.dot.hidden = this.state.hidden = !confirmed || !available;
      this.value.textContent = !available ? this.dataset.unavailable : !confirmed ? this.dataset.unknown : this.durationLabel;
      if (confirmed && available && this.dataset.dates === 'true') {
        this.updateDate();
        this.timer = setInterval(() => this.updateDate(), 60000);
      }
    }
    updateDate() {
      const first = Number(this.dataset.min), last = Number(this.dataset.max);
      if (!Number.isSafeInteger(first) || !Number.isSafeInteger(last) || first < 0 || last < first) return;
      const parts = new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(new Date());
      const p = Object.fromEntries(parts.map(part => [part.type, part.value]));
      const start = new Date(Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), 12));
      const addDays = days => {
        const date = new Date(start);
        if (days === 0) return date;
        if (days > 0 && (date.getUTCDay() === 6 || date.getUTCDay() === 0)) {
          date.setUTCDate(date.getUTCDate() + (date.getUTCDay() === 6 ? 2 : 1));
          days--;
        }
        const remainder = days % 5;
        const weekend = date.getUTCDay() + remainder > 5 ? 2 : 0;
        date.setUTCDate(date.getUTCDate() + Math.floor(days / 5) * 7 + remainder + weekend);
        return date;
      };
      const firstDate = addDays(first), lastDate = addDays(last);
      if (!Number.isFinite(firstDate.getTime()) || !Number.isFinite(lastDate.getTime())) return;
      const format = new Intl.DateTimeFormat(this.dataset.locale || 'de-DE', {timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric'});
      this.value.textContent = first === last ? format.format(lastDate) : `${format.format(firstDate)} – ${format.format(lastDate)}`;
    }
    async load(id) {
      id = String(id || '');
      if (!/^\d+$/.test(id) || id === this.pending || id === this.dataset.variant && this.dataset.confirmed === 'true' && !this.pending) return;
      this.request?.abort();
      this.request = new AbortController();
      const request = this.request;
      this.pending = id;
      clearInterval(this.timer);
      this.dataset.confirmed = 'false';
      this.dot.hidden = this.state.hidden = true;
      this.value.textContent = this.dataset.loading;
      this.setAttribute('aria-busy', 'true');
      if (this.body) this.body.replaceChildren(Object.assign(document.createElement('p'), {textContent: this.dataset.loading}));
      try {
        const url = new URL(this.dataset.url, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid product URL');
        url.searchParams.set('section_id', 'wohnjoy-delivery-data');
        url.searchParams.set('variant', id);
        let html;
        if (window.wohnjoyProductInfoRequest) {
          html = await window.wohnjoyProductInfoRequest(url, request.signal);
        } else {
          const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.any([request.signal, AbortSignal.timeout(12000)])});
          if (!response.ok) throw new Error('Delivery response unavailable');
          html = await response.text();
        }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const data = doc.querySelector('[data-wj-delivery-response]');
        if (!data || data.dataset.product !== this.dataset.product || data.dataset.variant !== id) throw new Error('Delivery response mismatch');
        if (request !== this.request || !this.isConnected) return;
        this.dataset.min = data.dataset.min;
        this.dataset.max = data.dataset.max;
        this.dataset.available = data.dataset.available;
        this.dataset.confirmed = data.dataset.confirmed;
        this.dataset.variant = id;
        this.durationLabel = data.querySelector('[data-wj-delivery-label]')?.textContent.trim() || this.dataset.unknown;
        if (this.body) this.body.replaceChildren(...[...data.querySelector('[data-wj-delivery-body]').childNodes].map(node => document.importNode(node, true)));
        this.renderValue();
      } catch (error) {
        if (request !== this.request || !this.isConnected) return;
        this.value.textContent = this.dataset.error;
        if (this.body) this.body.replaceChildren(Object.assign(document.createElement('p'), {textContent: this.dataset.error}));
      } finally {
        if (request === this.request) {
          this.pending = null;
          this.removeAttribute('aria-busy');
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
